export const auditLogSelector = state => (state.administration.auditLog.data.pagedCollection);
export const auditLogTotalPages = state => (state.administration.auditLog.data.totalPages);
